var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatternC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 10.1V6.31669C18.8333 5.14169 18.3 4.66669 16.975 4.66669H13.6083C12.2833 4.66669 11.75 5.14169 11.75 6.31669V10.0917C11.75 11.275 12.2833 11.7417 13.6083 11.7417H16.975C18.3 11.75 18.8333 11.275 18.8333 10.1Z",
    stroke: "#505152",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 19.475V16.1083C18.8333 14.7833 18.3 14.25 16.975 14.25H13.6083C12.2833 14.25 11.75 14.7833 11.75 16.1083V19.475C11.75 20.8 12.2833 21.3333 13.6083 21.3333H16.975C18.3 21.3333 18.8333 20.8 18.8333 19.475Z",
    stroke: "#505152",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25008 6.10002V2.31669C9.25008 1.14169 8.71675 0.666687 7.39175 0.666687H4.02508C2.70008 0.666687 2.16675 1.14169 2.16675 2.31669V6.09169C2.16675 7.27502 2.70008 7.74169 4.02508 7.74169H7.39175C8.71675 7.75002 9.25008 7.27502 9.25008 6.10002Z",
    stroke: "#505152",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25008 15.475V12.1083C9.25008 10.7833 8.71675 10.25 7.39175 10.25H4.02508C2.70008 10.25 2.16675 10.7833 2.16675 12.1083V15.475C2.16675 16.8 2.70008 17.3333 4.02508 17.3333H7.39175C8.71675 17.3333 9.25008 16.8 9.25008 15.475Z",
    stroke: "#505152",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternC);
export default __webpack_public_path__ + "static/media/pattern-c.faee1a5b9b82dfb30ec29a572850be48.svg";
export { ForwardRef as ReactComponent };